import { render, staticRenderFns } from "./WWDBlock.vue?vue&type=template&id=077595aa&scoped=true&lang=pug&"
import script from "./WWDBlock.vue?vue&type=script&lang=js&"
export * from "./WWDBlock.vue?vue&type=script&lang=js&"
import style0 from "./WWDBlock.vue?vue&type=style&index=0&id=077595aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077595aa",
  null
  
)

export default component.exports